import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { pageColors } from "../mock";
import { ArrowRight, Users, MessageSquare, Newspaper, Sparkles } from "lucide-react";

const Welcome = () => {
  const { current } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "TMM|WELCOME";
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <>
      <Header hoverColor={pageColors.contact} compact={false} />
      <div className="welcome-page">
        <div className="welcome-hero">
          <div className="welcome-eyebrow">
            <Sparkles size={14} /> Community of creatives
          </div>
          <h1 className="welcome-title" data-testid="welcome-title">
            <img src="/img/yi.png" alt="You're in!" className="welcome-yi-img" />
          </h1>
          <blockquote className="welcome-quote" data-testid="welcome-quote">
            <p>
              Welcome!* Use this community as a resource for collaborations,
              new thoughts, and opportunities! Let's grow together!
            </p>
            <p className="welcome-unbounded">U N B O U N D E D.</p>
          </blockquote>
        </div>

        <section className="welcome-block">
          <h2>What The Monde Mania is</h2>
          <p>
            TMM is a home for musicians, painters, designers, event-runners,
            writers, and anyone whose work is easier to feel than to file. It's
            not a portfolio site, an agency, or a scroll-hole — it's a
            community of creatives who show up for each other's work.
          </p>
          <p>
            Everything here is built by the people in it. You'll find members
            testing ideas out loud, dropping projects before the polish, and
            trading feedback that pushes them further. There is no membership
            fee. There is no gatekeeper except taste.
          </p>
        </section>

        <section className="welcome-block">
          <h2>How to make the most of this space</h2>
          <ul className="welcome-list">
            <li>
              <strong>Show up.</strong> Post in the Creators Room whether it's
              a finished thing or a first draft. Half-finished ideas are how
              collaborations start.
            </li>
            <li>
              <strong>Say something in Chat.</strong> A real hello lands better
              than a perfect intro. Everyone here was new once.
            </li>
            <li>
              <strong>Read the News Center.</strong> Drops, meet-ups, open
              calls, and community wins land there first.
            </li>
            <li>
              <strong>Reach out directly.</strong> Every profile has links.
              Message someone whose work sparks something. That's the whole
              point.
            </li>
            <li>
              <strong>Bring people in.</strong> If someone you know would love
              it here, send them to the Members page and vouch for them.
            </li>
          </ul>
        </section>

        <section className="welcome-block welcome-values">
          <h2>The house rules — keep it simple</h2>
          <ul className="welcome-list">
            <li>Be generous with feedback. Be honest, not cruel.</li>
            <li>Credit people. Tag collaborators. Link the work.</li>
            <li>Chat is public and moderated. Profanity and sensitive topics get auto-filtered.</li>
            <li>Report anything that feels off. We move fast on it.</li>
          </ul>
        </section>

        <section className="welcome-cta">
          <p className="welcome-cta-lead">
            Now the fun part — pick where to start:
          </p>
          <div className="welcome-cta-row">
            <Link to="/creators-room" className="btn-solid" data-testid="welcome-to-creators">
              <Users size={16} /> Creators Room
            </Link>
            <Link to="/chat" className="btn-solid" data-testid="welcome-to-chat">
              <MessageSquare size={16} /> Member Chat
            </Link>
            <Link to="/news" className="btn-ghost" data-testid="welcome-to-news">
              <Newspaper size={16} /> News Center
            </Link>
            <button
              className="btn-ghost"
              onClick={() => navigate(current ? `/members/${current.id}` : "/members")}
              data-testid="welcome-to-profile"
            >
              Finish your profile <ArrowRight size={14} />
            </button>
          </div>
        </section>

        <p className="welcome-signoff">— The Monde Mania</p>
      </div>
    </>
  );
};

export default Welcome;
